/**
 * Idle full-page reload (bundle freshness), not a timed refresh in the HTML document head.
 *
 * WCAG 2.2.1: limit is under 20 hours, not essential → users must be able to extend or otherwise
 * control the behavior. We implement **Extend** (Understanding 2.2.1): warn well before expiry
 * (`APP_RELOAD_WARNING_BEFORE_MS`) and simple actions to reset or turn off reload for the tab.
 */
export const APP_RELOAD_IDLE_MS = 14_400 * 1000;

/** How long before expiry to show the warning dialog (15 minutes; ≫ 20s minimum for extend). */
export const APP_RELOAD_WARNING_BEFORE_MS = 15 * 60 * 1000;
